export const LOCAL_STORAGE_KEYS = {
  LAYOUT: 'layout'
} as const;
export const DEBOUNCE_TIME = 500;
